export const config = {
  production: true,
  BASE_URL: "#{dns_api}#",
  API_PATH: "/api",
  ISSUER: "#{issuer}#",
  CLIENT_ID: "#{client_id}#",
  ENV_GROUP: "#{env_group}#"
};